'use client'
import { Icons } from 'components/common/icons'
import useScrollSpy from 'core/hooks/use-scroll-spy'
import { cn } from 'core/cn'
import Link from 'next/link'
import { Button } from './ui/button'

export default function Sidebar() {
	const activeSection = useScrollSpy('section')
	return (
		<div className="relative z-[49] bg-primary shadow-md sm:sticky sm:top-0">
			<div className="sticky top-0 z-1 flex h-screen flex-col items-center justify-between p-12 md:p-9 sm:h-12 sm:flex-row sm:px-[30px] sm:py-0 xs:px-3">
				<div className="sm:pl-[78px]">
					<Link
						href="/"
						title="Anabion Pharmaceutical Trading"
						className="logo block h-[249px] w-[24px] sm:h-[160px] sm:w-[16px] sm:origin-center sm:rotate-90"
					>
						<Icons.logo />
					</Link>
				</div>
				<nav className="menu mt-auto sm:mt-0 sm:hidden">
					<ul className="grid gap-7 [&>*]:rotate-180 [&>*]:[writing-mode:vertical-rl]">
						<li>
							<Link href="/#about" className={cn({ 'text-primary-foreground': activeSection == 'about' })}>
								About Us
							</Link>
						</li>
						<li>
							<Link href="/#contacts" className={cn({ 'text-primary-foreground': activeSection == 'contacts' })}>
								Contacts
							</Link>
						</li>
					</ul>
				</nav>

				<Button variant="white" size="sm" className="hidden w-fit font-bold sm:flex" asChild>
					<Link href="/#contacts">Write to us</Link>
				</Button>
			</div>
		</div>
	)
}
